import React, { useState, useEffect } from 'react';
import { Shield, X, Check, Cookie } from 'lucide-react';
import api from '../services/api';

export const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('nexo_cookie_consent');
    if (!consent) {
      // Pequeño delay para que no aparezca de golpe
      const timer = setTimeout(() => setIsVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = async () => {
    localStorage.setItem('nexo_cookie_consent', 'all');
    localStorage.setItem('nexo_cookie_consent_date', new Date().toISOString());
    setIsVisible(false);
    try {
      await api.post('/legal/cookie-consent', { accepted: true, preferences: { essential: true, preferences: true } });
    } catch (e) {
      // Ignorar si falla el log en backend, la preferencia local ya quedó
    }
  };

  const handleAcceptEssential = async () => {
    localStorage.setItem('nexo_cookie_consent', 'essential');
    localStorage.setItem('nexo_cookie_consent_date', new Date().toISOString());
    setIsVisible(false);
    try {
      await api.post('/legal/cookie-consent', { accepted: true, preferences: { essential: true, preferences: false } });
    } catch (e) {
      // Ignorar si falla
    }
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '20px',
      right: '20px',
      maxWidth: '680px',
      zIndex: 99999,
      background: '#ffffff',
      borderRadius: '16px',
      padding: '16px 20px',
      border: '1.5px solid #00df82',
      boxShadow: '0 12px 36px rgba(6, 60, 61, 0.22)',
      fontFamily: "'Plus Jakarta Sans', -apple-system, sans-serif",
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      animation: 'slideUp 0.3s ease-out'
    }}>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>

      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '36px',
            height: '36px',
            borderRadius: '10px',
            background: 'rgba(0, 223, 130, 0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <span style={{ fontSize: '18px' }}>🍪</span>
          </div>
          <div>
            <strong style={{ fontSize: '13.5px', color: '#063c3d', fontWeight: '800', display: 'block' }}>
              Uso de Cookies y Almacenamiento Técnico
            </strong>
            <span style={{ fontSize: '11px', color: '#64748b' }}>
              Pentágono Constructora • Protección de Datos (Ley 1581 de 2012)
            </span>
          </div>
        </div>

        <button
          type="button"
          onClick={handleAcceptEssential}
          title="Cerrar con configuración básica"
          style={{
            background: 'transparent',
            border: 'none',
            color: '#94a3b8',
            cursor: 'pointer',
            padding: '4px'
          }}
        >
          <X size={16} />
        </button>
      </div>

      <p style={{ margin: 0, fontSize: '12px', color: '#334155', lineHeight: '1.55' }}>
        Utilizamos cookies estrictamente esenciales y almacenamiento local para mantener tu sesión segura, guardar tus preferencias de planos y asegurar la trazabilidad legal de tus operaciones. No comercializamos tus datos con terceros ni utilizamos cookies de rastreo publicitario invasivo.
      </p>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', paddingTop: '4px' }}>
        <a
          href="/politicas"
          target="_blank"
          rel="noreferrer"
          style={{ fontSize: '11.5px', color: '#063c3d', fontWeight: '700', textDecoration: 'underline' }}
        >
          Ver Política Completa de Cookies y Privacidad
        </a>

        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            type="button"
            onClick={handleAcceptEssential}
            style={{
              padding: '8px 14px',
              borderRadius: '8px',
              background: '#f1f5f9',
              border: '1px solid #cbd5e1',
              color: '#475569',
              fontSize: '12px',
              fontWeight: '700',
              cursor: 'pointer'
            }}
          >
            Solo Esenciales
          </button>
          <button
            type="button"
            onClick={handleAcceptAll}
            style={{
              padding: '8px 16px',
              borderRadius: '8px',
              background: '#063c3d',
              border: 'none',
              color: '#ffffff',
              fontSize: '12px',
              fontWeight: '800',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              boxShadow: '0 2px 8px rgba(6, 60, 61, 0.25)'
            }}
          >
            <Check size={14} color="#00df82" /> Aceptar Todas
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
